import { createContext, useContext, useEffect, useState } from "react";
import { publicGet } from "./publicApi";
import { resolveMediaUrl } from "../utils/mediaUrl";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const CLUB_LOGO = "/logo512.png";
export const publicImages = {
  hero: "https://static.prod-images.emergentagent.com/jobs/bf6c3d8c-bb69-4407-a80f-3421fc7ad126/images/89d7357a5d918ed9f0adf953c27f04db5e7a7c5f78814f7bd3c449710aab9c29.jpeg",
  supporter: "https://static.prod-images.emergentagent.com/jobs/bf6c3d8c-bb69-4407-a80f-3421fc7ad126/images/3bb75ddf9051fa1f773b00ab573521cce7d39cd6f62f2da1c74909ba1913ef7d.jpeg",
  academy: "https://images.unsplash.com/photo-1622659097574-c814ee26068e?w=1400&q=85",
  pitch: "https://images.unsplash.com/photo-1765130729366-b54d7b2c8ea2?auto=format&fit=crop&w=1800&q=85",
  city: "https://images.unsplash.com/photo-1661155100640-37747341ad48?auto=format&fit=crop&w=1800&q=85",
};
export const mediaUrl = resolveMediaUrl;
const PublicDataContext = createContext({ club: null, teams: [], groups: [], products: [] });
export const usePublicData = () => useContext(PublicDataContext);

export const PublicDataProvider = ({ children }) => {
  const [data, setData] = useState({ club: null, teams: [], groups: [], products: [] });
  useEffect(() => {
    let active = true;
    const load = async () => {
      const keys = ["club", "teams", "groups", "products"];
      const results = await Promise.allSettled(["/club", "/teams", "/academy-groups", "/products"].map(path => publicGet(`${API}${path}`)));
      if (active) setData(prev => {
        const next = { ...prev };
        results.forEach((result, i) => { if (result.status === "fulfilled") next[keys[i]] = result.value.data; });
        return next;
      });
    };
    load(); window.addEventListener("focus", load);
    return () => { active = false; window.removeEventListener("focus", load); };
  }, []);
  return <PublicDataContext.Provider value={data}>{children}</PublicDataContext.Provider>;
};
